export const attributes = [
	'CPN Minutes',
	'National Minutes',
	'SMS',
	'Local and GCC Data',
	'International Call',
	'GoBiz Data',
	'GoBiz Minutes',
	'Data - Global',
];

export const productFilters = ['Nama Professional', 'Nama 2022', 'Nama 2021'];
export const customizedPlansFilters = ['Nama Others'];
export const customizePlanName = 'Nama Others';
export const plansToHide = ['Nama 2022'];
export const hiddenPlans = [];
